import { Services } from '@Shared.Angular/@types/services';
import { BpmnModeler } from '@Shared.Angular/flowingly.bpmn.modeler/@types/services';
import { getInjector } from '@Shared.Angular/flowingly.helper/serviceInjector';

/**
 * Hook to get angularJs service via injector
 * @typedef T - type of the service
 * @param name
 * @returns T - the angularJs service
 * @deprecated Use `getService` instead.
 */
export const useService = <T>(name: SharedServiceName): T =>
  getInjector().get(name) as T;

export type SharedServiceTypeMap = {
  APP_CONFIG: Services.APP_CONFIG;
  procedureApiService: Services.ProcedureApiService;
  permissionsService: Services.PermissionsService;
  flowsUtilityService: Services.FlowsUtilityService;
  browserUtilsService: Services.BrowserUtilsService;
  sessionService: Services.SessionService;
  $state: angular.ui.IStateService;
  appInsightsService: Services.AppInsightsService;
  pubsubService: Services.PubSubService;
  tempModelerUrlService: Services.TempModelerUrlService;
  flowinglyConstants: Services.FlowinglyConstants;
  workflowApiService: Services.WorkflowApiService;
  flowinglyDiagramService: Services.FlowinglyDiagramService;
  goService: GoJS;
  documentApiService: Services.DocumentApiService;
  BPMN_CONSTANTS: BpmnModeler.BpmnConstants;
  tagGroupApiService: Services.TagGroupApiService;
  notificationService: Services.NotificationService;
  [key: string]: unknown;
};

export const getService = <K extends SharedServiceName>(
  name: K
): SharedServiceTypeMap[K] =>
  getInjector().get(name) as SharedServiceTypeMap[K];
